import { Injectable } from '@angular/core';
import { VoiceLogger } from 'src/app/shared/models/logger/voice-logger';

type LoggerType = 'error' | 'info' | 'warn';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  error(...messages: any[]): void {
    const baseStringLog = `(itau-iframe) - [${this.getTimestamp()}] -`;
    console.error(baseStringLog, ...messages);
  }

  warn(...messages: any[]): void {
    const baseStringLog = `(itau-iframe) - [${this.getTimestamp()}] -`;
    console.warn(baseStringLog, ...messages);
  }

  info(...messages: any[]): void {
    const baseStringLog = `(itau-iframe) - [${this.getTimestamp()}] -`;
    console.info(baseStringLog, ...messages);
  }

  voiceLogger(props: VoiceLogger, type: LoggerType = 'info') {
    const { event } = props;
    const voiceLoggerMessage = this.voiceLoggerMessage(props);

    switch (type) {
      case 'error':
        console.error(voiceLoggerMessage, event ? event : '');
        break;
      case 'info':
        console.info(voiceLoggerMessage, event ? event : '');
        break;
      case 'warn':
        console.warn(voiceLoggerMessage, event ? event : '');
        break;
      default:
        console.info(voiceLoggerMessage, event ? event : '');
        break;
    }
  }

  private voiceLoggerMessage(props: VoiceLogger) {
    const { central, description, info } = props;
    const contactType =
      typeof info.isInbound === 'boolean'
        ? info.isInbound
          ? 'INBOUND'
          : 'OUTBOUND'
        : null;

    const loggerMessage = `(itau-iframe) - [${this.getTimestamp()}] - Central: ${central} | Contato: ${contactType} | Status: ${info.status} | ContactID: ${info.contactID} | SkillName: ${info.skillName} | ScreenPopUrl: ${info.screenPopUrl} ${description ? `| Descrição: ${description}` : ''} ${props.event ? '| Evento' : ''} `;
    return loggerMessage;
  }

  private getTimestamp(): string {
    return new Date().toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
    });
  }
}
